<template>
	<div class="pain-type-ai-result">
		<h1 class="pain-type-ai-result__title">
			<img src="~@/assets/img/pain-type-ai-result/logo.png" alt="おしえてAI 頭痛×気圧 あなたはどのタイプ？">
		</h1>

		<!-- 分析精度 -->
		<aside class="pain-type-ai-result__accuracy">
			<div class="pain-type-ai-result__accuracy--wrapper">
				<img src="~@/assets/img/pain-type-ai-result/analysis_accuracy_bg.png" alt="分析精度">
				<div class="pain-type-ai-result__accuracy--wrapper-count">
					<p>{{ recordCount }}</p>
				</div>
				<div class="pain-type-ai-result__accuracy--wrapper-accuracy">
					<img :src="require(`@/assets/img/pain-type-ai-result/meter_${meterImgNumber}.gif`)" alt="分析メーター">
				</div>
			</div>
		</aside>
		<!-- / 分析精度 -->

		<!-- AI結果 -->
		<section class="pain-type-ai-result__type">
			<h2>
				<img id="type_image" :src="require(`@/assets/img/pain-type-ai-result/check_type_${typeNumber}.png`)" alt="気圧タイプ">
			</h2>
			<a
				href="javascript:void(0);"
				class="share-button gtm-link_click_count01"
				data-gtm-event-cat-label="最上部の「結果をシェア」をタップ"
				data-gtm-event-act-label="ai_result_share_01"
				@click="onShare('type_image')"
			>
				結果をシェア
			</a>
		</section>
		<!-- / AI結果 -->

		<!-- あなたの痛みデータ -->
		<section class="pain-type-ai-result__data">
			<h2 class="pain-type-ai-result__data--title">
				<img src="~@/assets/img/pain-type-ai-result/title.png" alt="あなたの痛みデータ">
			</h2>
			<section class="pain-type-ai-result__chart">
				<h3 class="pain-type-ai-result__chart--heading">気圧の影響を受ける傾向</h3>
				<div class="pain-type-ai-result__chart--canvas" id="canvas_wrap">
					<canvas id="myChart"></canvas>
				</div>
				<a
					href="javascript:void(0);"
					class="share-button gtm-link_click_count01"
					data-gtm-event-cat-label="中部の「結果をシェア」をタップ"
					data-gtm-event-act-label="ai_result_share_02"
					@click="onShare('chart_image')"
				>
					結果をシェア
				</a>
				<p class="pain-type-ai-result__chart--explanation">{{ graphExplanation[typeNumber] }}</p>
			</section>
			<section class="pain-type-ai-result__note">
				<h3 class="pain-type-ai-result__note--heading">この気圧変化に注意！</h3>
				<img :src="require(`@/assets/img/pain-type-ai-result/graph_image_type${typeNumber}.png`)" alt="注意が必要な気圧グラフ" class="pain-type-ai-result__note--image">
				<h4 class="pain-type-ai-result__note--subheading">{{ typeText[typeNumber] }}</h4>
				<p class="pain-type-ai-result__note--explanation">{{ noteText[typeNumber] }}</p>
				<div class="pain-type-ai-result__note--advice">
					<div class="pain-type-ai-result__note--advice-textbox">
						<p>{{ adviceText[meterImgNumber - 1] }}</p>
						<img src="~@/assets/img/pain-type-ai-result/advice_hiroshi.png" alt="アドバイス">
					</div>
				</div>
			</section>
		</section>
		<!-- / あなたの痛みデータ -->

		<!-- そんなあなたに！ -->
		<section class="pain-type-ai-result__recommendation" v-if="!isSugotokuAppFlag">
			<h2 class="pain-type-ai-result__recommendation--title">
				<span class="pain-type-ai-result__recommendation--title-first">そんなあなたに！</span>
				<span class="pain-type-ai-result__recommendation--title-second">頭痛ーるより</span>
				<span class="pain-type-ai-result__recommendation--title-third">オススメの読み物をご紹介</span>
			</h2>
			<a v-for="(item, index) in columnSentence[`type_${typeNumber}`]" :key="`column-${index}`" class="pain-type-ai-result__recommendation--column gtm-link_click_count01" :data-gtm-event-cat-label="item[4]" :data-gtm-event-act-label="item[5]" @click="onColumn(item[3])">
				<div class="pain-type-ai-result__recommendation--column-image">
					<img :src="require(`@/assets/img/pain-type-ai-result/${item[2]}.png`)" :alt="`コラム${index+1}`">
				</div>
				<div class="pain-type-ai-result__recommendation--column-text">
					<p>{{ item[0] }}</p>
					<p>{{ item[1] }}</p>
				</div>
			</a>
		</section>
		<!-- / そんなあなたに！ -->

		<a
			href="javascript:void(0);"
			class="share-button gtm-link_click_count01"
			data-gtm-event-cat-label="最下部の「結果をシェア」をタップ"
			data-gtm-event-act-label="ai_result_share_03"
			@click="onShare('type_image')"
		>
			結果をシェア
		</a>

		<a
			href="native://reset_ai_report"
			class="reset-button gtm-link_click_count01"
			data-gtm-event-cat-label="「おしえてAIをリセットする」をタップ"
			data-gtm-event-act-label="ai_result_reset"
		>
			おしえてAIをリセットする
		</a>
	</div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex'

// ライブラリ
import Chart from 'chart.js/auto'

export default {
	name: 'PainTypeAiResult',
	data () {
		return {
			radarChart: null,
			recordCount: null, // 記録回数
			meterImgNumber: 1, // 分析メーター画像番号
			typeNumber: 1, // 予測タイプ番号 【A（気圧の下降タイプ）: 1、B（気圧変化前タイプ）: 2, C（急激な気圧変化タイプ）: 3, D（気圧変化以外タイプ）: 4】
			graphExplanation: [ // グラフの解説
				'あなたは『気圧の下降』タイプのようです。気圧の上昇時や安定時には、あまり不調が起きない傾向がありますが、気圧が下がっている時は要注意です。レーダーチャートを見てみますと、「低下中」と「大きく低下中」の項目が大きくなっています。これは「気圧の下降」によって不調が起こりやすいことを示しています。気圧が大きく下がっている時はもちろんですが、それほど大きくない下降に対しても、注意する必要があります。気圧グラフの線がくぼんでいるような時間帯は気を付けてください。',
				'あなたは『気圧の変化前』タイプのようです。気圧が下降する前から不調が起こりやすいことが、一番の特徴です。レーダーチャートの「低下前」の項目が大きくなっていて、気圧が今安定していても、その後に下がっていくときは不調が起こりやすくなりますので、要注意です。また、「V字型」や「上昇中」でも不調が起こる傾向があります。不調が長く続く可能性がありますので、頭痛ーるコラムを読んだりして、対策をするのもよさそうです。',
				'あなたは『急激な気圧変化』タイプのようです。気圧が下がる時にも、気圧が上がる時にも不調が起こりやすくなります。つまり、急激な気圧変化に特に注意が必要と言えそうです。レーダーチャートを見ても、「大きく低下中」や「V字型」の項目が大きくなっています。気圧が大きく下がっている時や、大きく下がった後に上昇へと変わるタイミングで、特に不調が起こっています。気圧アラートと概ね一致しますので、気圧グラフをしっかり確認するようにして下さいね。',
				'あなたは『気圧変化以外』のタイプのようです。レーダーチャートを見ますと「安定時」の項目が、頭痛ーるユーザーの平均と比べると大きくなっているようです。気圧が安定している時でも、不調が起こりやすくなる傾向があります。湿度の変化によっても不調になる可能性があるため、雨天時は注意が必要です。それ以外では生活習慣や身体自身の変化が要因となる可能性もありますので、Fitbit連携や生理記録機能などもご活用してみて下さい。'
			],
			typeText: [ // タイプ
				'気圧の下降',
				'気圧の変化前',
				'急激な気圧変化',
				'気圧変化以外'
			],
			noteText: [ // 注意の解説
				'気圧グラフ(左)のように気圧が大きく下降している時は、特に不調が起こりやすくなります。また、気圧グラフ(右)のように、気圧が少し下降している時にも不調が起こりやすい傾向がありますので、お気を付け下さい。気圧の下降全般に対して不調が起こりやすくなりますので、気圧が大きく下降している時だけでなく、それほど大きくない下降に対しても注意が必要です。',
				'気圧グラフ(左)のように気圧が下がる前から、不調が起こりやすくなります。アラートが出ていない時間帯でも、次の時間帯に爆弾マークがある時は要注意です。また、不調が長く続く傾向がありますので、気圧が大きく低下する時もそうですが、気圧グラフ(右)のようにV字型の時や、上昇が続く時にも注意が必要です。',
				'急激な気圧変化で不調が起こりやすくなる傾向があります。気圧グラフ(左)のように気圧が大きく下降している時、気圧グラフ(右)のように気圧が大きく下がり、V字型に変化していく時が、特に要注意です。気圧アラートと不調が一致することが多いですので、「警戒」「注意」「上昇注意」のアラートが出ている時間帯は、特に注意が必要です。',
				'気圧変化以外でも不調が起こりやすくなる傾向があります。気圧グラフ(左)のように、気圧が大きく変化していなくても、天気が崩れていて「やや注意」のアラートが出ているような時は要注意です。気圧の影響を受けにくくても、気圧グラフ(右)のように気圧がとても大きく変化する際は、不調が起こる可能性がありますので、お気を付け下さい。'
			],
			adviceText: [ // アドバイス解説
				'今回の結果はあくまで参考程度じゃ。記録を付けていくとAIの分析精度は高まるようじゃ。',
				'AIの分析精度が高まりつつあるようじゃ。不調があった時は記録を付けていってほしいのじゃ。',
				'AIの分析精度が高まってきたようじゃ。AIをある程度信頼しても良い頃のようじゃ。',
				'AIの分析精度はかなり高いようじゃ。おしえてAIを参考に、少しでもあなたの不調を軽減したいのじゃ。',
				'もの凄い記録の量じゃ。お身体を大切にこれからも頭痛ーるを使ってほしいのじゃ。'
			],
			columnSentence: { // おすすめコラム
				'type_0': [
					[
						'オススメ①', // タイトル
						'気象病・低気圧頭痛を予防しよう！自律神経を整えるヨガ', // コラム説明
						'column_recommendation1_1', // 画像名
						'prepare_autonomic_nerves', // コラムID
						'「気圧の下降」タイプのコラム①をタップ', // gtmイベント計測用
						'ai_result_column_A_01' // gtmイベント計測用
					],
					[
						'オススメ②',
						'気圧の変化でなぜ体調不良が起こるの？ 気圧が自律神経に与える影響と対処法',
						'column_recommendation1_2',
						'post-16174',
						'「気圧の下降」タイプのコラム②をタップ',
						'ai_result_column_A_02'
					],
					[
						'オススメ③',
						'気圧の変化でつらいのは自分だけじゃない！「みんなの痛みナウ」のご紹介',
						'column_recommendation1_3',
						'itami-now',
						'「気圧の下降」タイプのコラム③をタップ',
						'ai_result_column_A_03'
					]
				],
				'type_1': [
					[
						'オススメ①',
						'「気象病対策」体の水や気の流れを良くするツボを刺激してみよう',
						'column_recommendation2_1',
						'stimulate_acupuncture_point',
						'「気圧の変化前」タイプのコラム①をタップ',
						'ai_result_column_B_01'
					],
					[
						'オススメ②',
						'気象の変化がストレスに？体調が悪くなるメカニズム',
						'column_recommendation2_2',
						'tenkitu_mechanism',
						'「気圧の変化前」タイプのコラム②をタップ',
						'ai_result_column_B_02'
					],
					[
						'オススメ③',
						'頭痛ーるウィジェットがさらに便利になりました！',
						'column_recommendation2_3',
						'post-19821',
						'「気圧の変化前」タイプのコラム③をタップ',
						'ai_result_column_B_03'
					]
				],
				'type_2': [
					[
						'オススメ①',
						'ストレスによる頭痛対策に！ マインドフルネス瞑想',
						'column_recommendation4_1',
						'post-10471',
						'「気圧の急激な変化」タイプのコラム①をタップ',
						'ai_result_column_D_01'
					],
					[
						'オススメ②',
						'気圧上昇時にも体調不良が起こるのはなぜ？',
						'column_recommendation4_2',
						'post-22295',
						'「気圧の急激な変化」タイプのコラム②をタップ',
						'ai_result_column_D_02'
					],
					[
						'オススメ③',
						'気圧の変化でつらいのは自分だけじゃない！「みんなの痛みナウ」のご紹介',
						'column_recommendation4_3',
						'itami-now',
						'「気圧の急激な変化」タイプのコラム③をタップ',
						'ai_result_column_D_03'
					]
				],
				'type_3': [
					[
						'オススメ①',
						'「花の癒し」でストレス緩和',
						'column_recommendation3_1',
						'post-27188',
						'「気圧の変化以外」タイプのコラム①をタップ',
						'ai_result_column_C_01'
					],
					[
						'オススメ②',
						'気圧の変化だけではない？頭痛を引き起こす要因と体調管理',
						'column_recommendation3_2',
						'headache_factor',
						'「気圧の変化以外」タイプのコラム②をタップ',
						'ai_result_column_C_02'
					],
					[
						'オススメ③',
						'睡眠データはこんな風に役立ちます！「スマートウォッチで健康管理」',
						'column_recommendation3_3',
						'post-30311',
						'「気圧の変化以外」タイプのコラム③をタップ',
						'ai_result_column_C_03'
					]
				]
			},
			chartTitle: [ // レーダーチャートのタイトル
				['小さな下降にも要注意！'],
				['気圧が下がる前から要注意！'],
				['気圧が下がる時も上がる時も', '要注意！'],
				['不調の要因は気圧以外の', '可能性あり!?']
			],
			chartYourData: [], // 分析結果クラスタリングデータ（ユーザー）
			chartEveryoneData: [], // 分析結果クラスタリングデータ（みんなの平均）
			isSugotokuAppFlag: false
		}
	},
	created () {
	},
	mounted () {
		// 分析結果取得
		this.setData()
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['premiumType', 'isAndroid']),
		...mapGetters('ai', ['resultOfAnalysisData'])
	},

	methods: {
		// NOTE: レーダーチャートの設定
		setRadarChart () {
			let canvas = document.getElementById('myChart')
			let ctx = canvas.getContext('2d')
			const titleChangeCalculation = this.chartTitle[this.typeNumber].length === 1
			const paddingTop = titleChangeCalculation ? 320 * 0.0625 : 320 * 0.03125 // 横幅320＆チャートタイトルの改行が存在する場合20
			const paddingBottom = 320 * 0.16875 // 320の時54
			const textPaddingBottom = titleChangeCalculation ? 320 * 0.2375 : 320 * 0.19375 // 横幅320＆チャートタイトルの改行が存在する場合76
			let img = new Image()
			img.src = require('@/assets/img/pain-type-ai-result/chart_bg.png')
			Chart.defaults.font.family = `'M+ C Type-1 (basic latin) Medium', 'M+ Type-1 (general-j) Medium', 'sans-serif'`
			const data = {
				labels: [
					'気圧低下',
					'大きく低下',
					'気圧V字',
					'気圧上昇',
					'気圧安定',
					'気圧低下前'
				],
				datasets: [
					{
						label: 'あなたのデータ',
						data: [
							this.chartYourData[2], // クラスター2:気圧低下
							this.chartYourData[3], // クラスター3:大きく低下
							this.chartYourData[4], // クラスター4:気圧V字
							this.chartYourData[5], // クラスター5:気圧上昇
							this.chartYourData[0], // クラスター0:気圧安定
							this.chartYourData[1] // クラスター1:気圧低下前
						],
						fill: true,
						backgroundColor: 'rgba(255, 173, 0, 0.6)',
						borderColor: '#FFAD00',
						pointBackgroundColor: '#FFAD00',
						pointBorderColor: '#FFAD00',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: 'rgb(255, 99, 132)'
					},
					{
						label: 'みんなの平均',
						data: [
							this.chartEveryoneData[2], // クラスター2:気圧低下
							this.chartEveryoneData[3], // クラスター3:大きく低下
							this.chartEveryoneData[4], // クラスター4:気圧V字
							this.chartEveryoneData[5], // クラスター5:気圧上昇
							this.chartEveryoneData[0], // クラスター0:気圧安定
							this.chartEveryoneData[1] // クラスター1:気圧低下前
						],
						fill: true,
						backgroundColor: 'rgba(30, 190, 187, 0.25)',
						borderColor: '#1EBEBB',
						pointBackgroundColor: '#1EBEBB',
						pointBorderColor: '#1EBEBB',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: 'rgb(54, 162, 235)'
					}
				]
			}
			const config = {
				type: 'radar',
				data: data,
				options: {
					responsive: false,
					layout: {
						padding: {
							top: paddingTop,
							bottom: paddingBottom
						}
					},
					elements: {
						line: {
							borderWidth: 1.5
						},
						point: {
							pointRadius: 2
						}
					},
					animation: false,
					scales: {
						r: {
							ticks: {
								min: 0,
								max: 200,
								maxTicksLimit: 4,
								count: 4,
								display: false
							},
							grid: {
								display: false
							},
							angleLines: {
								display: false
							},
							pointLabels: {
								display: false
							}
						}
					},
					plugins: {
						legend: {
							display: false
						},
						title: {
							display: true,
							text: this.chartTitle[this.typeNumber],
							color: '#1EBEBB',
							font: {
								size: 16,
								lineHeight: 1.5
							},
							padding: {
								bottom: textPaddingBottom
							}
						}
					}
				},
				plugins: [
					{
						beforeDraw: function (chart) {
							const ratio = img.height / img.width
							const imgHeight = 320 * ratio
							// 背景の描画
							ctx.fillStyle = '#DFF6F5'
							ctx.fillRect(0, 0, chart.width, imgHeight)
							// 画像の描画
							chart.ctx.drawImage(img, 0, 0, chart.width, imgHeight)
						}
					}
				]
			}

			img.onload = function () {
				const ratio = img.height / img.width
				const imgHeight = 320 * ratio
				canvas.width = 320
				canvas.height = imgHeight
				this.radarChart = new Chart(ctx, config)
			}
		},

		// 分析結果のセット
		setData () {
			// スゴ得Android判定
			this.isSugotokuAppFlag = this.premiumType.premium_type_code === 8 && this.isAndroid

			this.recordCount = this.resultOfAnalysisData.record_count
			this.meterImgNumber = this.recordCount <= 19 ? 1 : this.recordCount <= 29 ? 2
				: this.recordCount <= 49 ? 3 : this.recordCount <= 99 ? 4 : 5
			this.typeNumber = this.resultOfAnalysisData.pain_type
			this.chartYourData = this.resultOfAnalysisData.user_clusters
			this.chartEveryoneData = this.resultOfAnalysisData.average_clusters
			this.setRadarChart()
		},

		// コラム画面に遷移（URLスキーム）
		onColumn (columnNo) {
			window.location.href = `native://open_column/${columnNo}`
		},

		// 結果シェア（base64に変換して、アプリに共有する）
		onShare (e) {
			const command = {
				'method': 'native://share',
				'base64edImage': null
			}
			if (e === 'chart_image') {
				const canvas = document.getElementById('myChart')
				const base64 = canvas.toDataURL('image/png')
				command['base64edImage'] = base64
			} else {
				const obj = document.getElementById('type_image')
				const canvas = document.createElement('canvas')
				canvas.width = 1280
				canvas.height = 1080
				const ctx = canvas.getContext('2d')
				ctx.drawImage(obj, 0, 0, canvas.width, canvas.height)
				const base64 = canvas.toDataURL('image/png')
				command['base64edImage'] = base64
			}
			if (typeof webkit !== 'undefined') {
				// iOS（URLスキーム）
				webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(command)) // eslint-disable-line
			} else if (typeof Android !== 'undefined') {
				// Android（URLスキーム）
				Android.execCommand(JSON.stringify(command)) // eslint-disable-line
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

$font-size-22: 1.375rem;
$font-size-23: 1.4375rem;
$font-size-26: 1.625rem;

$spacing-31: 1.9375rem;
$spacing-32: 2rem;
$spacing-34: 2.125rem;
$spacing-37: 2.3125rem;
$spacing-109: 6.8125rem;

$border-radius-3: 0.1875rem;
$border-radius-5: 0.3125rem;

$text-zutoolgreen: $primary;

$background-zutoolgreen: $primary;

.pain-type-ai-result {
	padding-bottom: $spacing-37;
	background: $background-primary !important;

	&__title {
		margin: 0;
		padding: $spacing-10 0 $spacing-8;
		img {
			width: 100%;
			margin: 0;
			display: block
		}
	}

	&__accuracy {
		width: 100%;
		&--wrapper {
			width: 87.5%;
			margin: 0 auto;
			position: relative;
			box-sizing: border-box;
			img {
				width: 100%;
				margin: 0;
				display: block;
			}
			&-count {
				width: 56.428%;
				position: absolute;
				text-align: center;
				top: 40%;
				left: 0;
				p {
					margin: 0;
					font-family: $lp-family-primary;
					font-size: $font-size-26;
					font-weight: 500;
					font-style: normal;
					color: $text-primary;
				}
			}
			&-accuracy {
				width: 32.5%;
				position: absolute;
				text-align: center;
				top: 36%;
				right: 6%;
			}
		}
	}

	&__type {
		margin: $spacing-26 0 $spacing-20;
		h2	{
			margin: 0 0 $spacing-20;
		}
		img {
			width: 100%;
			margin: 0;
		}
	}

	&__data {
		margin: 0;
		&--title {
			margin: 0;
			line-height: 0;
			img {
				width: 100%;
			}
		}
	}

	&__chart {
		background: #DFF6F5;
		&--heading {
			margin: 0 auto;
			width: 81.25%;
			text-align: center;
			font-size: $font-size-20;
			font-family: $lp-family-tertiary;
			font-style: normal;
			padding: $spacing-8 $spacing-10;
			border-radius: $border-radius-5;
			background-color: $text-seconday;
			color: $text-primary;
		}
		&--canvas {
			width: 100%;
			margin: 0 auto $spacing-20;
			padding: 0 2.1875%;
			box-sizing: border-box;
			canvas {
				width: 100% !important;
				height: auto !important;
				display: block;
			}
		}
		&--explanation {
			font-size: $font-size-16;
			font-style: normal;
			font-weight: 400;
			font-family: $lp-family-primary;
			padding: $spacing-20 $spacing-20 $spacing-40;
			margin: 0;
			color: $text-primary;
		}
	}

	&__note {
		background: #DFF6F5;
		&--heading {
			margin: 0 auto;
			width: 81.25%;
			text-align: center;
			font-size: $font-size-20;
			font-family: $lp-family-tertiary;
			font-style: normal;
			padding: $spacing-8 $spacing-10;
			border-radius: $border-radius-5;
			background-color: $text-seconday;
			color: $text-primary;
		}
		&--image {
			width: 87.5%;
			display: block;
			margin: $spacing-14 auto 0;
		}
		&--subheading {
			width: 53.125%;
			margin: $spacing-16 auto;
			position: relative;
			text-align: center;
			display: block;
			font-family: $lp-family-secondary;
			font-weight: 500;
			font-style: normal;
			font-size: $font-size-20;
			color: $text-zutoolgreen;
		}
		&--subheading::before {
			content: "";
			display: inline-block;
			position: absolute;
			left: 0;
			bottom: -4px;
			width: 100%;
			height: 3px;
			border-radius: $border-radius-3;
			background: $background-zutoolgreen;
		}
		&--explanation {
			font-size: $font-size-16;
			font-family: $lp-family-primary;
			font-style: normal;
			font-weight: 400;
			padding: 0 $spacing-20 $spacing-34;
			margin: 0;
			color: $text-primary;
		}
		&--advice {
			margin: 0 auto;
			padding-bottom: $spacing-40;
			&-textbox {
				width: 87.5%;
				margin: 0 auto;
				box-sizing: border-box;
				padding: $spacing-16 $spacing-16 $spacing-16 $spacing-109;
				background: $background-primary;
				border-radius: 0.625rem;
				position: relative;
				p {
					margin: 0;
					font-size: $font-size-14;
					font-family: $lp-family-primary;
					color: #F66C62;
				}
				img {
					width: 40.7142%;
					position: absolute;
					top: -14px;
					left: -10px;
				}
			}
		}
	}

	&__recommendation {
		&--title {
			width: 100%;
			font-family: $lp-family-tertiary;
			text-align: center;
			&-first {
				width: 48.4375%;
				display: block;
				position: relative;
				font-size: $font-size-18;
				text-align: center;
				margin: $spacing-34 auto $spacing-8;
				color: $text-zutoolgreen;
				&::before {
					position: absolute;
					left: -9px;
					top: 0;
					content: "";
					width: 2px;
					height: 100%;
					background: $background-zutoolgreen;
					border-radius: $border-radius-3;
					transform: rotate(-25deg);
				}
				&::after {
					position: absolute;
					content: "";
					right: -9px;
					top: 0;
					width: 2px;
					height: 100%;
					background: $background-zutoolgreen;
					border-radius: $border-radius-3;
					transform: rotate(25deg);
				}
			}
			&-second {
				width: 90%;
				display: block;
				position: relative;
				margin: 0 auto;
				text-align: center;
				font-size: $font-size-16;
				font-family: $lp-family-secondary;
				color: $text-primary;
				z-index: 1;
			}
			&-third {
				width: 90%;
				display: block;
				font-size: $font-size-22;
				font-family: $lp-family-secondary;
				color: $text-primary;
				position: relative;
				margin: 0 auto;
				z-index: 1;
				&::before {
					content: "";
					display: inline-block;
					position: absolute;
					left: 0;
					bottom: 0;
					width: 100%;
					height: 14px;
					border-radius: 1.875rem;
					background: #FFECA5;
					z-index: -1;
				}
			}
		}
		&--column {
			width: 87.5%;
			margin: $spacing-20 auto 0;
			display: flex;
			justify-content: space-between;
			&-image {
				width: 50%;
				padding-right: $border-radius-5;
				img {
					width: 100%;
					display: block;
				}
			}
			&-text {
				width: 50%;
				padding-left: $border-radius-5;
				p {
					margin: 0;
					font-size: $font-size-14;
				}
				p:nth-child(1) {
					color: #FFAD00;
					font-family: $lp-family-tertiary;
				}
				p:nth-child(2) {
					color: #4C4C4C;
					font-family: $lp-family-primary;
				}
			}
			&:last-child {
				margin-bottom: $spacing-32;
			}
		}
	}
}

.share-button {
	width: 62.5%;
	display: block;
	white-space: nowrap;
	margin: 0 auto;
	padding: $spacing-14 $spacing-31;
	font-family: $lp-family-secondary;
	font-size: $font-size-23;
	font-style: normal;
	font-weight: 400;
	text-align: center;
	box-sizing: border-box;
	border-radius: 2.5rem;
	background-color: #FFAD00;
	color: $text-seconday;
	text-decoration: none;
	line-height: $line-height-1;
}

.reset-button {
	width: 45%;
	display: block;
	white-space: nowrap;
	margin: $spacing-20 auto 0;
	font-size: $font-size-12;
	font-family: $lp-family-primary;
	color: $text-primary;
	text-align: center;
}
</style>
